module.exports = __webpack_public_path__ + "img/cate-qrcode.571d7182.png";